
const colors=[
'rgba(255, 173, 173, 1)',
'rgba(255, 194, 173, 1)',	
'rgba(255, 214, 173, 1)',	
'rgba(255, 222, 173, 1)',	
'rgba(255, 235, 173, 1)',
'rgba(255, 255, 173, 1)',	
'rgba(235, 255, 173, 1)',	
'rgba(214, 255, 173, 1)',	
'rgba(194, 255, 173, 1)',	
'rgba(173, 255, 173, 1)',	
'rgba(173, 255, 194, 1)',	
'rgba(173, 255, 214, 1)',	
'rgba(173, 255, 235, 1)',	
'rgba(173, 255, 255, 1)',	
'rgba(173, 235, 255, 1)',	
'rgba(173, 214, 255, 1)',	
'rgba(173, 194, 255, 1)',
'rgba(173, 173, 255, 1)',	
'rgba(194, 173, 255, 1)',
'rgba(214, 173, 255, 1)',	
'rgba(235, 173, 255, 1)',	
'rgba(255, 173, 255, 1)',	
'rgba(255, 173, 235, 1)',	
'rgba(255, 173, 214, 1)',	
'rgba(255, 173, 194, 1)',	
'rgba(255, 173, 173, 1)',
'rgba(255, 222, 173, 1)',	
'rgba(253, 222, 175, 1)',	
'rgba(251, 222, 177, 1)',	
'rgba(249, 221, 180, 1)',	
'rgba(247, 221, 182, 1)',	
'rgba(245, 220, 184, 1)',	
'rgba(243, 220, 186, 1)',	
'rgba(241, 220, 188, 1)',	
'rgba(239, 219, 190, 1)',
'rgba(255, 153, 0, 1)',
'rgba(230, 138, 0, 1)',
'rgba(204, 122, 0, 1)',
'rgba(179, 107, 0, 1)'

]

export default colors;